import {adminRoutes} from '@app/admin/admin-routes';
import {driveRoutes} from '@app/drive/drive-routes';
import {authRoutes} from '@common/auth/auth-routes';
import {authGuard} from '@common/auth/guards/auth-route';
import {auth} from '@common/auth/use-auth';
import {RootErrorElement, RootRoute} from '@common/core/common-provider';
import {commonRoutes} from '@common/core/common-routes';
import {notificationRoutes} from '@common/notifications/notification-routes';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {FullPageLoader} from '@ui/progress/full-page-loader';
import {Fragment} from 'react';
import {createBrowserRouter, redirect} from 'react-router';

export const appRouter = createBrowserRouter(
  [
    {
      id: 'root',
      element: <RootRoute />,
      errorElement: <RootErrorElement />,
      hydrateFallbackElement: <FullPageLoader screen />,
      children: [
        {
          // app has no landing page, "/" is only an entry point
          path: '/',
          loader: () =>
            auth.isLoggedIn
              ? redirect(getBootstrapData().auth_redirect_uri)
              : redirect('/login'),
          element: <Fragment />,
        },
        ...driveRoutes,
        ...adminRoutes,
        ...authRoutes(),
        ...notificationRoutes,
        ...commonRoutes,
        {
          path: 'api-docs',
          loader: () =>
            authGuard({permission: 'api.access', requireLogin: false}),
          lazy: () => import('@common/swagger/swagger-api-docs-page'),
        },
      ],
    },
  ],
  {
    basename: getBootstrapData().settings.html_base_uri,
  },
);
